export type MultiSelectOption = {
  label: string
  key: string | number | boolean
  selected?: boolean
}
